<template>
    <div>
      <avue-crud
      ref="crud"
      v-model="form"
        :option="option"
        :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
        @search-change="searchChange"
        @search-reset="searchReset"
      @refresh-change="refreshChange"
        @current-change="currentChange"
        @size-change="sizeChange"
      @on-load="onLoad"
        >
          <template slot-scope="scope" slot="menu">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">
              详情
            </el-button>
          </template>
        </avue-crud>

      <el-dialog
        title="应急物资入库详情"
        :visible.sync="detailDialogVisible"
        width="900px"
        append-to-body
        :close-on-click-modal="false"
        @closed="resetDetailDialog"
      >
        <div v-loading="detailLoading" class="entry-detail">
          <div class="detail-section-title">入库信息</div>
          <div class="detail-grid">
            <div
              v-for="item in detailFields"
              :key="item.prop"
              class="detail-item"
              :class="{ 'detail-item--wide': item.span === 24 }"
            >
              <span class="detail-label">{{ item.label }}</span>
              <span class="detail-value">{{ formatDetailValue(item) }}</span>
            </div>
          </div>

          <div class="detail-section-title detail-storage-title">储备点入库数量</div>
          <el-table :data="detailStorageList" border size="small" empty-text="暂无储备点入库数据">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="storagePointName" label="储备点" min-width="220" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatEmpty(scope.row.storagePointName) }}
              </template>
            </el-table-column>
            <el-table-column prop="actualQuantity" label="入库数量" min-width="140" align="right">
              <template slot-scope="scope">
                {{ formatEmpty(scope.row.actualQuantity) }}
              </template>
            </el-table-column>
            <el-table-column prop="unit" label="单位" min-width="100" align="center">
              <template slot-scope="scope">
                {{ formatDicLabel("unit", scope.row.unit || detailForm.unit) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="detailDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, getDetail } from "./api";
import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";
  
  export default {
  mixins: [crudMixins],
    data() {
      return {
      form: {},
      detailDialogVisible: false,
      detailLoading: false,
      detailForm: {},
      detailFields: [
        { label: "入库单号", prop: "inOrderNo" },
        { label: "入库批号", prop: "inBatchNo" },
        { label: "物资编码", prop: "materialCode" },
        { label: "物资名称", prop: "materialName" },
        { label: "物资类型", prop: "materialType", dicProp: "materialType" },
        { label: "采购日期", prop: "purchaseDate" },
        { label: "有效期至", prop: "expiryDate" },
        { label: "规格型号", prop: "specModel" },
        { label: "总入库数量", prop: "totalQuantity" },
        { label: "数量单位", prop: "unit", dicProp: "unit" },
        { label: "录入人", prop: "createName" },
        { label: "录入时间", prop: "createTime" },
        { label: "备注", prop: "remark", span: 24 },
      ],
      apiConfig: { getList },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        selection: false,
        addBtn: false, // 禁用新增按钮
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 100,
        column: [
          {
            label: "入库单号",
            prop: "inOrderNo",
            overHidden: true,
            minWidth: 120,
            search: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "入库批号",
            prop: "inBatchNo",
            overHidden: true,
            minWidth: 150,
            maxlength: 100,
            search: true,
            rules: rulesInput(2),
          },
          {
            label: "物资编码",
            prop: "materialCode",
            overHidden: true,
            minWidth: 120,
            search: true,
            rules: rulesInput(2),
          },
          {
            label: "物资名称",
            prop: "materialName",
            overHidden: true,
            minWidth: 150,
            maxlength: 100,
            search: true,
            rules: rulesInput(2),
          },
          {
            label: "物资类型",
            prop: "materialType",
            search: true,
            overHidden: true,
            width: 120,
            type: "select",
            dicData: [
              { label: "防护用品", value: "1" },
              { label: "救援设备", value: "2" },
              { label: "医疗用品", value: "3" },
              { label: "通讯设备", value: "4" },
              { label: "消防器材", value: "5" },
              { label: "食品饮料", value: "6" },
              { label: "其他物资", value: "7" },
            ],
            rules: rulesInput(2),
          },
          {
            label: "采购日期",
            prop: "purchaseDate",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            rules: rulesInput(2),
          },
          {
            label: "有效期至",
            prop: "expiryDate",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            rules: rulesInput(2),
          },
          {
            label: "规格型号",
            prop: "specModel",
            overHidden: true,
            width: 120,
            type: "input",
            maxlength: 100,
            placeholder: "请输入规格型号",
            rules: rulesInput(2),
          },
          {
            label: "总入库数量",
            prop: "totalQuantity",
            type: "number",
            precision: 0,
            min: 0,
            max: 999999,
            overHidden: true,
            width: 120,
            placeholder: "总入库数量",
            rules: rulesInput(2),
          },
          {
            label: "数量单位",
            prop: "unit",
            search: true,
            overHidden: true,
            width: 100,
            type: "select",
            dicData: [
              { label: "个", value: "1" },
              { label: "台", value: "2" },
              { label: "套", value: "3" },
              { label: "件", value: "4" },
              { label: "箱", value: "5" },
              { label: "包", value: "6" },
              { label: "瓶", value: "7" },
              { label: "盒", value: "8" },
              { label: "吨", value: "9" },
              { label: "公斤", value: "10" },
              { label: "升", value: "11" },
              { label: "米", value: "12" },
              { label: "其他", value: "13" },
            ],
            rules: rulesInput(2),
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            maxlength: 500,
            span: 24,
            minRows: 3,
            hide: true,
          },
          {
            label: "录入人",
            prop: "createName",
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "录入时间",
            prop: "createTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig("录入时间", { type: "datetimerange" }),
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
          },
          {
            label: "修改人",
            prop: "updateName",
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "修改时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
        ],
      },
      defaultParams: {},
    };
  },
  computed: {
    detailStorageList() {
      return this.detailForm.emergencyMSExtList || [];
    },
  },
  methods: {
    handleDetail(row) {
      if (!row || !row.id) {
        this.$message.warning("未获取到入库记录ID");
        return;
      }
      this.detailDialogVisible = true;
      this.detailLoading = true;
      getDetail(row.id).then(res => {
        this.detailForm = res.data.data || res.data || {};
      }).catch(() => {
        this.$message.error("获取详情失败");
      }).finally(() => {
        this.detailLoading = false;
      });
    },
    resetDetailDialog() {
      this.detailForm = {};
      this.detailLoading = false;
    },
    formatDetailValue(item) {
      const value = this.detailForm[item.prop];
      if (item.dicProp) {
        return this.formatDicLabel(item.dicProp, value);
      }
      return this.formatEmpty(value);
    },
    formatDicLabel(prop, value) {
      if (value === undefined || value === null || value === "") {
        return "-";
      }
      const column = this.option.column.find(item => item.prop === prop);
      const dicData = column && column.dicData ? column.dicData : [];
      const target = dicData.find(item => String(item.value) === String(value));
      return target ? target.label : value;
    },
    formatEmpty(value) {
      if (value === undefined || value === null || value === "") {
        return "-";
      }
      return value;
    },
  },
};
  </script>

<style scoped lang="scss">
p {
  margin: 0;
}
.entry-detail {
  min-height: 240px;
}

.detail-section-title {
  margin-bottom: 12px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  font-weight: 600;
  line-height: 18px;
}

.detail-storage-title {
  margin-top: 22px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.detail-item {
  display: flex;
  min-height: 40px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  line-height: 20px;
}

.detail-item--wide {
  grid-column: 1 / -1;
}

.detail-label {
  flex: 0 0 110px;
  padding: 10px 12px;
  background: #f5f7fa;
  color: #606266;
  text-align: right;
}

.detail-value {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  color: #303133;
  word-break: break-all;
}
</style>
